import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';

import { GET_GROUP_BUYINGS_MENU } from '@/store/menu/constants';
import { UPDATE_DRAFT_ORDER } from '@/store/orders/constants';
import { GET_STORE } from '@/store/store/constants';
import { ALLOW_EDIT_TYPES, ORDER_STATUS_WITH_TYPE_TEXT, SNACKBAR_TYPES } from '@/utils/constants';

import OrderDetail from '../OrderDetail/OrderDetail.vue';
import StoreSelector from '../StoreSelector/StoreSelector.vue';

export default {
  name: 'OrderConfig',
  components: {
    StoreSelector,
    OrderDetail,
  },
  props: {
    allowEditType: {
      default: ALLOW_EDIT_TYPES.ALL,
      type: Number,
      validator: (val) => Object.values(ALLOW_EDIT_TYPES).includes(val),
    },
    orderType: {
      default: ORDER_STATUS_WITH_TYPE_TEXT.DRAFT,
      type: String,
      validator: (val) => Object.values(ORDER_STATUS_WITH_TYPE_TEXT).includes(val),
    },
    title: {
      default: '設定訂購資訊',
      type: String,
    },
    viewMode: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isGettingData: false,
      menu: null,
      originMenuId: null,
      reselectStore: false,
    };
  },
  computed: {
    ...mapState('menu', ['rawMenu']),
    ...mapState('orders', ['draftOrder']),
    ...mapGetters('orders', [
      'currentDraftId',
      'draftMenuId',
      'draftStoreId',
    ]),
    allowEditAll() {
      return this.allowEditType === ALLOW_EDIT_TYPES.ALL;
    },
    canSelectStore() {
      return !(this.draftStoreId && this.draftMenuId && !!this.menu);
    },
    isDraft() {
      return this.orderType === ORDER_STATUS_WITH_TYPE_TEXT.DRAFT;
    },
    loading() {
      return this.isGettingData;
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  async created() {
    if (!this.draftStoreId) {
      return;
    }
    this.isGettingData = true;

    try {
      const { menus, ...storeInfo } = await this.getStore(this.draftStoreId);
      if (!this.menu && this.draftMenuId && !this.isDraft) {
        const { params: { orderId } = {} } = this.$route || {};
        await this.getGroupBuyingsMenu(orderId);
        this.menu = {
          id: this.draftMenuId,
          name: this.rawMenu?.meta?.name || '',
          storeInfo,
          ...this.rawMenu,
        };
      }
    } catch (error) {
      const { message: msg = '' } = error;
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '取得菜單失敗，請重新選擇店家',
        msg,
      });
      this.menu = null;
    }
    this.isGettingData = false;
  },
  watch: {
    menu: {
      handler(newVal) {
        if (this.currentDraftId && !this.viewMode) {
          this.updateDraftOrder({
            menuId: newVal?.id || null,
            storeId: newVal?.storeInfo.id || null,
          });
          this.$emit('update-draft');
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('menu', {
      getGroupBuyingsMenu: GET_GROUP_BUYINGS_MENU,
    }),
    ...mapActions('store', {
      getStore: GET_STORE,
    }),
    ...mapMutations('orders', {
      updateDraftOrder: UPDATE_DRAFT_ORDER,
    }),
    prevStep() {
      if (!this.originMenuId) {
        this.originMenuId = this.menu?.id;
      }
      this.menu = null;
      this.reselectStore = true;
      this.updateDraftOrder({
        menuId: null,
        storeId: null,
      });
    },
  },
};
